export default __webpack_public_path__ + "static/media/settings512.03f33520.png";